module.exports = __webpack_public_path__ + "img/bul_history_apply.799672f9.svg";